
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import Config from "./config"

import OCROrderApi from "@/api/ocr-order-api";
import { RouterLink } from "vue-router";
import UploadApi from "@/api/upload-api";
import CustomUploadApi from "@/api/custom-upload";
import { Dialog } from "vant";

type MainType = OCROrderApi.IOcrOrderListItem & { cover?: string }
@Component({ name: "ocr-order-list", })
export default class OCROrderList extends Vue {
    listLoader = { loading: false, noMore: false }
    files: UploadApi.IUploadViewModel[] = []
    dataSource: Array<MainType> = []
    detailDataSource: Array<OCROrderApi.ISimpleDetailList> = []
    expiredInfo = { status: 0, expiredAt: null as NString }

    getDateTime = Config.getDateTime
    /**0:订单，1:明细 */
    listType = 0



    created() { }
    async mounted() {
        //this.onSearch()
        var date = await OCROrderApi.getSeviceTime();
        if (date) {
            var time = Date.parse(date);
            this.expiredInfo.expiredAt = new Date(time).toLocaleDateString();
            time += 24 * 60 * 60 * 1000;
            // console.error(time, Date.now())
            this.expiredInfo.status = time > Date.now() ? 1 : -1;
        }
    }
    //webResult: IPagedResultData<MainType> = {} as any
    webQuery: OCROrderApi.IOCROrderQuery = { Page: 0, Limit: 15, Type: OCROrderApi.KeyType.PartNo } as any

    keywordType = [
        { text: "型号", value: OCROrderApi.KeyType.PartNo },
        { text: "仓库位置", value: OCROrderApi.KeyType.Location },
        { text: "理货单", value: OCROrderApi.KeyType.OrdrNo },
        { text: "理货单备注", value: OCROrderApi.KeyType.OrderRemark },
        { text: "型号备注", value: OCROrderApi.KeyType.DetailRemark },
    ]

    createOrder() {
        if (this.expiredInfo.status == 1) return this.$router.push({ name: 'ocr-order-editor' });
        if (this.expiredInfo.status == 0) Dialog.alert({ message: "OCR理货服务尚未开通" });
        else Dialog.alert({ message: "OCR理货服务已经过期" });
    }

    // get dataSource() { return this.webResult.Items || [] }

    async onSearch(pIdx?: number) {

        // console.error("afafafafa")
        if (pIdx == -1) {
            this.webQuery.Page = 0;
            this.dataSource = [];
            this.detailDataSource = []
        }
        this.webQuery.Page = (this.webQuery.Page || 0) + 1;
        this.listType = [OCROrderApi.KeyType.DetailRemark, OCROrderApi.KeyType.PartNo].includes(this.webQuery.Type) ? 1 : 0;
        if (!this.webQuery.Keyword) this.listType = 0;
        // console.error("bbb", this.listType, this.webQuery.Keyword)
        try {
            if (this.listType) await this.queryDetail()
            else await this.queryList();
        } catch {
            this.listLoader.noMore = true;
        }
        finally {
            this.listLoader.loading = false;
        }
    }

    async queryList() {
        this.listLoader.loading = true;
        const r = await OCROrderApi.takeList(this.webQuery);
        var ids = r.Items.map(e => e.Id);
        if (ids.length) {
            UploadApi.getFiles({ RelationIds: ids, RelationType: Config.UploadFiles.hk_receipt_order_goods })
                .then(this.onFiles)
        }

        this.dataSource.push(...r.Items)
        this.listLoader.noMore = this.webQuery.Page > 10 || r.Page >= r.PageCount;
    }

    async queryDetail() {
        this.listLoader.loading = true;
        const r = await OCROrderApi.queryDetail(this.webQuery);
        this.detailDataSource.push(...r.Items)
        this.listLoader.noMore = this.webQuery.Page > 500 || r.Page >= r.PageCount;
    }

    onFiles(files: UploadApi.IFileDetailView[]) {
        this.files.push(...files)
        files.forEach(e => {
            var d = this.dataSource.find(m => m.Id == e.RelationId);
            if (d) this.$set(d, "cover", CustomUploadApi.getFileUrl(e.Id!))
        })
    }

    toDetail(m: { Id: number }) {
        this.$router.push({ name: "ocr-order-detail", query: { id: m.Id, type: this.webQuery.Type, keyword: this.webQuery.Keyword } as any })
    }
}
